import isApp from "@/ts/mobile/isApp";
import tm from '@/ts/theme'

export default function () {
    if(isApp()) {
        document.addEventListener("deviceready", () => {
            tm.checkAndSet(tm.getTheme())
        }, false);
    }
}